import axios from "axios";
import { useState } from "react";
import { Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import { getIntelApiUrl } from "../../../utils/intelAPIUrl";
import { productDropdownConfig } from "./header-product-linking-dropdown-list";

export default function ProductLinkingDropdown({ parentProductArr, callNavigation, close }) {
  const [getInTouchPopUp, setGetInTouchPopUp] = useState(false);
  const [selectedInactiveProduct, setSelectedInactiveProduct] = useState("");
  const [loading, setLoading] = useState(false);
  const productConfig = productDropdownConfig() ?? null;

  const onClickSubProducts = (key, url) => {
    if (key && url) {
      callNavigation(key, url);
    }
  };

  const handleGetInTouchSubmit = () => {
    setLoading(true);
    const userData = JSON.parse(localStorage.getItem("userData"))?.session_id;
    const expiredProducts = parentProductArr.filter((item) => item.is_subscribed && item.days_left < -1).map((item) => item.product_name);

    const params = {
      planId: userData || null,
      countries: expiredProducts.join(","),
      key: "All Apps Compliance",
      ...(selectedInactiveProduct && { product: selectedInactiveProduct }),
    };

    axios
      .get(getIntelApiUrl("notifySales"), { params })
      .then((res) => {
        const message = res.data?.message || "Something went wrong. Please try again later!";
        if (res.data?.status?.toUpperCase() === "SUCCESS") {
          toast.success(selectedInactiveProduct ? "Thanks for showing interest. Your account manager will get in touch with you shortly." : message);
        } else {
          toast.error(message);
        }
      })
      .catch(() => toast.error("Something went wrong. Please try again later!"))
      .finally(() => {
        setGetInTouchPopUp(false);
        setSelectedInactiveProduct("");
        setLoading(false);
      });
  };

  const isProductActive = (item) => item.is_subscribed && item.days_left >= 0;

  return (
    <div className="tw-px-3 tw-py-4 tw-space-y-4 tw-w-[500px] tw-max-h-[60vh] tw-overflow-y-auto">
      {productConfig &&
        parentProductArr.map((item) => {
          if (item.product_name === "userManagement" || !productConfig[item.product_name]) return null;
          const product = productConfig[item.product_name];
          const handleProductClick = () => {
            if (isProductActive(item)) {
              product.redirectionUrl ? onClickSubProducts(product.redirectionKey, product.redirectionUrl) : close();
            } else {
              setGetInTouchPopUp(true);
              setSelectedInactiveProduct(item.product_ui_name);
            }
          };

          return (
            <div className={`tw-flex tw-justify-between tw-items-center tw-text-gray-900 tw-cursor-pointer tw-gap-4`} onClick={handleProductClick} key={item.product_name}>
              <div className={`tw-flex tw-justify-between tw-items-center tw-gap-2 ${isProductActive(item) ? "tw-cursor-pointer" : "tw-cursor-not-allowed tw-opacity-50"}`}>
                <img src={product.imageUrl} width={24} height={24} alt={`${item.name}-icon`} className="mr-2" />
                <div>
                  <div className="tw-text-label-md tw-pb-0.5 tw-font-medium">{item.product_ui_name}</div>
                  <div className="tw-text-label-sm tw-font-medium">{item.product_ui_description}</div>
                </div>
              </div>
              <div>
                <img
                  src={
                    isProductActive(item)
                      ? "https://res.cloudinary.com/drzta9shk/image/upload/v1694768003/intel/icons/nav_arrow_xsqxgi.svg"
                      : "https://res.cloudinary.com/drzta9shk/image/upload/v1687950013/intel/icons/Lightning-alt_mlxyoq.svg"
                  }
                  alt={isProductActive(item) ? "navigation-arrow" : "lightning"}
                />
              </div>
            </div>
          );
        })}

      {getInTouchPopUp ? (
        <Modal
          show={getInTouchPopUp}
          onHide={() => {
            setGetInTouchPopUp(false);
            setSelectedInactiveProduct("");
          }}
          keyboard={false}
          centered={true}
          size="sm"
          className="getInTouch">
          <Modal.Header>
            <div>
              <img src="https://res.cloudinary.com/drzta9shk/image/upload/v1684478309/intel/icons/Lightning-alt_t9mkjb.svg" alt="lightning" />
            </div>
          </Modal.Header>
          <Modal.Body>
            <div className="label-md-regular p-3">
              You do not have access to <span className="label-md-medium">{selectedInactiveProduct}</span>. Connect with your account manager to get access.
            </div>
          </Modal.Body>
          <Modal.Footer>
            <button type="button" className="trademo-export-compliance-cancel-btn w-25" onClick={() => setGetInTouchPopUp(false)}>
              Cancel
            </button>
            <button type="button" className="btn btn-primary trademo-new-btn" onClick={handleGetInTouchSubmit} disabled={loading}>
              Get in Touch
            </button>
          </Modal.Footer>
        </Modal>
      ) : (
        <></>
      )}
    </div>
  );
}
